package com.example.readingnotes.data.remote.api

object ApiRoutes {
    // Auth routes
    const val AUTH_LOGIN = "/api/auth/login"
    const val AUTH_LOGOUT = "/api/auth/logout"
    const val AUTH_ME = "/api/auth/me"
    const val AUTH_REGISTER = "/api/auth/register"
    const val AUTH_LOGIN_USERNAME = "/api/auth/login-username"
    const val AUTH_VERIFY_TOTP = "/api/auth/verify-totp"
    const val AUTH_SETUP_TOTP = "/api/auth/setup-totp"
    const val AUTH_USERNAME = "/api/auth/username"
    const val AUTH_SEND_VERIFICATION_CODE = "/api/auth/send-verification-code"
    const val AUTH_VERIFY_EMAIL = "/api/auth/verify-email"
    const val AUTH_LOGIN_WITH_CODE = "/api/auth/login-with-code"

    fun checkUsername(username: String) = "/api/auth/check-username/$username"

    // Profile routes
    const val USERS_PROFILE = "/api/users/profile"

    // ============================================================================
    // OIDC routes
    // ============================================================================

    const val OIDC_LOGIN = "/api/auth/oidc/login"
    const val OIDC_CALLBACK = "/api/auth/oidc/callback"
    const val OIDC_REFRESH = "/api/auth/oidc/refresh"
    const val OIDC_LOGOUT = "/api/auth/oidc/logout"
    const val OIDC_CONFIG = "/api/auth/oidc/config"

    // Post routes
    const val POSTS = "/api/posts"

    fun post(id: String) = "/api/posts/$id"

    fun postStatus(id: String) = "/api/posts/$id/status"

    // Comment routes
    fun comments(postId: String) = "/api/posts/$postId/comments"

    fun comment(id: String) = "/api/comments/$id"

    const val COMMENTS_BULK_DELETE = "/api/comments/bulk-delete"

    // Audit routes
    const val AUDIT_LOGS = "/api/audit-logs"

    // Image routes
    const val IMAGES_UPLOAD_URL = "/api/images/upload-url"
    const val IMAGES_CONFIRM = "/api/images/confirm"
    const val IMAGES = "/api/images"
    const val IMAGES_EDIT = "/api/images/edit"

    fun image(id: String) = "/api/images/$id"

    // Tag routes
    const val TAGS = "/api/tags"

    fun tag(id: String) = "/api/tags/$id"

    fun tagsForPost(postId: String) = "/api/posts/$postId/tags"

    fun addTagToPost(postId: String, tagId: String) = "/api/posts/$postId/tags/$tagId"

    const val TAGS_POPULAR = "/api/tags/popular"

    const val TAGS_SEARCH = "/api/tags/search"

    // Search routes
    const val SEARCH = "/api/search"
    const val SEARCH_SUGGESTIONS = "/api/search/suggestions"
    const val SEARCH_HISTORY = "/api/search/history"

    // Push notification routes
    const val PUSH_SETTINGS = "/api/push/settings"
    const val PUSH_NOTIFICATIONS = "/api/push/notifications"
    const val PUSH_NOTIFICATIONS_READ_ALL = "/api/push/notifications/read-all"

    fun pushNotification(id: String) = "/api/push/notifications/$id/read"

    // ============================================================================
    // Stripe Connect routes
    // ============================================================================

    const val STRIPE_CONNECT_ONBOARDING_LINK = "/api/stripe-connect/onboarding-link"
    const val STRIPE_CONNECT_STATUS = "/api/stripe-connect/status"
    const val STRIPE_CONNECT_CALLBACK = "/api/stripe-connect/callback"
    const val STRIPE_CONNECT_REFRESH = "/api/stripe-connect/refresh"
    const val STRIPE_CONNECT_WEBHOOK = "/api/webhooks/stripe-connect"

    // ============================================================================
    // Paid Content routes
    // ============================================================================

    fun setPostPrice(tenantSlug: String, postId: String) =
        "/api/t/$tenantSlug/posts/$postId/set-price"

    fun purchaseCheckout(contentId: String) = "/api/purchases/$contentId/checkout"

    fun purchaseStatus(contentId: String) = "/api/purchases/$contentId/status"

    fun purchaseRefund(purchaseId: String) = "/api/purchases/$purchaseId/refund"

    const val PURCHASES = "/api/purchases"

    fun salesDashboard(tenantSlug: String) = "/api/t/$tenantSlug/sales"
}
